var _path, _mask, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShot = function SvgShot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "m2 32.486 1.372 1.372L9.34 27.89 7.967 26.52z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "shot_svg__a",
    width: 28,
    height: 27,
    x: 5,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.878 2.97h27.01v25.782H5.878z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "m24.967 5.34 1.59 1.59-3.673 3.673-1.59-1.59L20.08 7.8l-2.37 2.37 1.214 1.215L5.878 24.43l3.455 3.454a2.963 2.963 0 0 0 4.19 0l10.95-10.95 1.215 1.214 2.37-2.37-1.213-1.215-1.59-1.589 3.672-3.673 1.59 1.59 2.37-2.372-5.55-5.55z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "m5.878 24.43 3.453 3.453a2.966 2.966 0 0 0 4.194 0l9.441-9.441-11.12.019z",
    clipRule: "evenodd"
  })));
};
export default SvgShot;